package com.iregained.site.components.sections.product.styles

import com.iregained.site.theme.toSitePalette
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.css.TransitionTimingFunction
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.selectors.hover
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.s

val ChecklistInteractiveStyle = CssStyle {
    base {
        Modifier
            // 1. Increased top/bottom padding creates a massive, stable hover target
            .padding(left = 12.px, top = 16.px, bottom = 16.px, right = 16.px)
            // 2. THE FIX: Permanent 4px border stops layout recalculation jitter
            .borderLeft(4.px, LineStyle.Solid, Colors.Transparent)
            .borderRadius(topRight = 8.px, bottomRight = 8.px)
            // 3. Removed padding/border animations, keeping only color and transform
            .transition(
                Transition.of("transform", 0.2.s, TransitionTimingFunction.EaseOut),
                Transition.of("background-color", 0.2.s),
                Transition.of("border-color", 0.2.s)
            )
    }
    hover {
        val palette = colorMode.toSitePalette()
        Modifier
            // 4. THE FIX: Hardware-accelerated sliding doesn't break the cursor hitbox
            .translateX(8.px)
            .borderLeft(4.px, LineStyle.Solid, palette.brand.primary) // Only change color
            .backgroundColor(palette.custom.lightGray)
    }
}

val NeuroscienceItemStyle = CssStyle {
    base {
        Modifier
            .transition(Transition.of("transform", 0.4.s))
    }
    hover {
        Modifier.translateY((-8).px) // Smooth upward float on hover
    }
}